import { verifyLogin } from './../../model/user.model';
import { Util } from './../../helpers/utilities';
import { AppService } from './../../app.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants, MessageUtil } from 'src/app/helpers/messages';
import { BaseUrlService } from 'src/app/api/base-url.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm:FormGroup
  errorMsg: string;
  currentDate = new Date().getFullYear()
  payload = new verifyLogin
  

  loading: boolean;
  userData: any;
  forgotPassword: boolean;
  codeloading: boolean;
  emailSent: string = '';
  linksent: boolean;
  resetloading: boolean;
  back: boolean = true;
  errormsg: string;
  resetError: boolean = false;
  resetLink: string;
  errorLogin: boolean = false;
  errorDisplay;
  // authUrl = 
  constructor(private fb:FormBuilder, private router:Router, private app: AppService,
    private authUrl:BaseUrlService
    ) { 
      this.resetLink = this.authUrl._authUrl

      
    }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      'email':['', [Validators.required, Validators.email]],
      'password':['', Validators.required]
    })

    localStorage.clear()
    
  }

  signIn() {
    this.errorMsg = ''
    
    if (this.loginForm.invalid) {
      this.errorMsg = 'Invalid Login Details'
      return
    }
    // this.router.navigateByUrl('app')
    this.loading = true;
    this.payload.username = this.loginForm.value.email.toLowerCase(); 
    this.payload.password = this.loginForm.value.password.toLowerCase();

    this.app.userService.verifyLogin(this.payload)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {        
        this.app.helperService.saveToStore(Constants.LOGIN_USER,res['data'])
        
        this.router.navigate(['/app/settings'])
        this.loading = false
        this.app.setLoginStatus()
        // this.app.snackBar.open(MessageUtil.SUCCESS, 'Dismiss', {
        //   duration:MessageUtil.TIMEOUT_DURATION
        // }) 
      }
      else { 
        this.loading = false
        this.errorLogin = true
        this.errorDisplay = res['data']
        setTimeout(()=>{                          
          this.errorLogin = false;
        }, 8000);
        // console.log(this.errorDisplay)
        // this.app.snackBar.open(res['data'], 'Dismiss', {
        //   duration:MessageUtil.TIMEOUT_DURATION
        // }) 
      }
    }, err => {
      this.loading = false 
      this.errorLogin = true
      this.errorDisplay = MessageUtil.SAVE_NOT_DONE
      setTimeout(()=>{                          
        this.errorLogin = false;
      }, 8000);
      // this.app.snackBar.open(MessageUtil.SAVE_NOT_DONE, 'Dismiss', {
      //   duration:MessageUtil.TIMEOUT_DURATION
      // })       
    })
  
  }

  login() {
    // this.allowAccess(this.userData.roles)
    // this.app.setLoginStatus(true)
    // this.app.util.setToken(this.userData.authTokenInfo.access_token)
    // this.app.util.saveToStore(Constants.LOGIN_USER, this.userData)

   

  }

  openForgetPassword() {
    this.forgotPassword = !this.forgotPassword
  }

  resetPassword() {
    this.codeloading = true
    
    let resetLink = `${this.resetLink}%23/reset` 
    // window.location.origin + '/doiapp/reset'
    this.errormsg = ''
    this.resetError = false

    

    this.app.userService.initiateResetPassword(this.emailSent, resetLink)
    .subscribe(res => {
      if (res['message'] == MessageUtil.RESPONSE_SUCCESS) {
        this.errormsg = ''
        this.codeloading = false
        this.app.snackBar.open('Operation Successful', 'Dismiss', {
          duration:MessageUtil.TIMEOUT_DURATION
        }) 
        this.linksent = true           
      }

      else { 
        this.resetError = true
        this.codeloading = false
        this.errormsg = res['data']
      }
      }, err => {
        this.resetError = true
        this.codeloading = false
        this.errormsg = MessageUtil.INTERNAL_SERVER_ERROR
            
      })



  }

  backToLogin(){ 
    this.resetloading = false
    // this.back = false
    this.linksent = false
    this.forgotPassword = false
  }
}
